import { Flex } from 'antd';
import styles from './choose-channel-type.module.scss';
import { useTranslation } from 'react-i18next';
import type { FC } from 'react';
import { Text } from '@shared/ui/antd';
import { ChannelTypeCards } from '../../../channel-type-cards/channel-type-cards';
import type { ChannelCreatableType } from '@modules/channels/lib/channel-type';

interface ChooseChannelTypeProps {
  selectChooseChannelType: (type: ChannelCreatableType) => void;
}

export const ChooseChannelType: FC<ChooseChannelTypeProps> = ({ selectChooseChannelType }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'channels' });

  return (
    <Flex vertical gap={16} className={styles.root}>
      <Text variant="xl" fontWeight={700} style={{ textAlign: 'center' }}>
        {t('emptyHeadline')}
      </Text>

      <ChannelTypeCards onSelect={selectChooseChannelType} />
    </Flex>
  );
};
